import React from 'react';
import './Footer.css';
import { Link } from "react-router-dom";

import logo from '../../assets/images/logo_sarsindialiaison.jpg';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Footer Top Section */}
        <div className="footer-top">
          {/* Logo Section */}
          <div className="footer-logo">
            <img src={logo} alt="SARS India Liaison Pvt. Ltd." className="footer-logo-img" />
            <p className="footer-tagline">Keeping Compliance <br/>in Check..</p>
          </div>

          {/* Navigation Links */}
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="footer-contact">
            <h4>Contact Us</h4>
            <address>
              <p>Plot No: 9N16, Cowork Venue, 4th Floor,<br /> Archbishop's House,<br />Satyanagar, Bhubaneswar, 751007</p>
              <p>Phone: <a href="tel:+919938662786">+91 9776522386</a></p>
                 <p>Email: <a href="mailto:sarsindialiaison@gmail.com">sarsindialiaison@gmail.com</a></p>
              <p>Email: <a href="mailto:contact@sarsindialiaison.com">contact@sarsindialiaison.com</a></p>
            </address>
            <div className="footer-social">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} SARS India Liaison Pvt. Ltd. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
